// @flow
import React, { Component } from 'react';
import { get, isString } from 'lodash';

import { truncate } from 'Components/utils/string/string.util';
import { COLORS } from 'Components/utils/color/colors';

import { ThumbnailMenu } from 'Components/frameworks/thumbnail-menu/ThumbnailMenu.jsx';
import { ThumbnailPush } from 'Components/frameworks/thumbnail-push/ThumbnailPush.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { Tile } from 'Components/frameworks/tile/Tile.jsx';

type Props = {
  allBlocks: *,
  otherProps?: {},
  trackingData?: TrackingData,
};

export default class SectionBlocks extends Component<Props> {
  renderTile(tile: *, index: number) {
    const { trackingData } = this.props;

    return tile ? (
      <div className="w-full md:w-1/3 p-2" key={index}>
        <Tile
          catchline={get(tile, 'content.subTitle', '')}
          color={tile.color || COLORS.PRUNE}
          link={{ url: tile.href }}
          text={get(tile, 'content.description', '')}
          title={get(tile, 'content.title', '')}
          trackingData={trackingData}
        />
      </div>
    ) : null;
  }

  renderBlocks(thumbnail: *, index: number) {
    const className = get(this.props, 'otherProps.displayLocationType', false)
      ? 'w-1/4 p-2'
      : 'w-1/2 md:w-1/3 p-2';

    const { trackingData } = this.props;

    return thumbnail ? (
      <div className={className} key={index}>
        <ThumbnailMenu
          color={thumbnail.color || COLORS.PRUNE}
          label={get(thumbnail, 'block.label', '')}
          link={get(thumbnail, 'block.href', '')}
          menus={get(thumbnail, 'block.details', []).map(({ label, href }) => ({
            label,
            trackingData,
            url: href,
          }))}
          thumbnail={{ imageUrl: get(thumbnail, 'block.image', '') }}
          trackingData={trackingData}
        />
      </div>
    ) : null;
  }

  renderPush(item: *, index: number) {
    const trackingData = {
      actionGA: 'main_push_offers',
      labelGA: `${item.label}-${index + 1}`,
    };

    const image = { imageUrl: item.img };

    return (
      <div className="w-full sm:w-1/3 p-2" key={index}>
        <ThumbnailPush
          className="h-full"
          label={item.label}
          link={item.href}
          thumbnail={image}
          trackingData={trackingData}
        >
          <h3 className="reset-heading font-bold mb-1 text-md">{item.descriptionTitle}</h3>
          <Text
            className="overflow-hidden"
            color={COLORS.WHITE}
            text={truncate(item.descriptionText, 115)}
          />
        </ThumbnailPush>
      </div>
    );
  }

  mapToComponent(blocks: *) {
    blocks = isString(blocks) ? JSON.parse(blocks) : blocks;
    return blocks.map((block, index) => {
      if (get(block, 'Introduction', false)) {
        return this.renderTile(block.Introduction, index);
      }
      if (get(block, 'LinksBlock')) {
        return this.renderBlocks(block.LinksBlock, index);
      }
      if (get(block, 'ImageAndTitleTopAndTextBottom', false)) {
        return this.renderPush(block.ImageAndTitleTopAndTextBottom, index);
      }
      return null;
    });
  }

  render() {
    return <div className="flex flex-wrap -m-2">{this.mapToComponent(this.props.allBlocks)}</div>;
  }
}
